module.exports = __webpack_public_path__ + "media/images/client-servepro-2-967a015008e1c0a7ad40c9a95e1ce59f.png";